import { Box, Typography, Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import basicImage from 'assets/images/help-general-search-basic.png';
import pagingImage from 'assets/images/help-general-search-paging.png';
import activeRefineImage from 'assets/images/help-general-search-refine-active.png';
import refineImage from 'assets/images/help-general-search-refine.png';
import sortingImage from 'assets/images/help-general-search-sorting.png';
import HelpImage from 'ui/help/HelpImage';
import { DomId } from 'constants/DomId';

// TODO internationalize if we end up caring about it

const HelpGeneralPLP = () => {
  return (
    <Box>
      <Typography variant='body1'>
        Search is the primary feature of this application, and has a wide
        variety of features. You can initiate a basic keyword search by simply
        typing into the search input and using the 'Enter' key. This will land
        you on the search results page with products associated with this search
        term. This term may search on more fields than just the item title; you
        can search for things like brands, item numbers, UPCs, etc.
      </Typography>
      <HelpImage imageSrc={basicImage} alt='basic search entry' />
      <Typography variant='body1'>
        You have some options once you have product results. The simplest
        options are pagination, and sorting. You can sort your results by
        clicking on column headers where it is available (first image), and you
        can adjust the page view size and page number to your liking (second
        image), shown below.
      </Typography>
      <HelpImage imageSrc={sortingImage} alt='how to sort a column' />
      <HelpImage imageSrc={pagingImage} alt='how to change paging' />
      <Typography variant='body1'>
        Another useful option on the search results page is the ability to
        customize the view to your liking. You can show/hide columns so only
        information relevant to you for an item is shown in the search results.
        More information about how to customize your views can be found at{' '}
        <Link component={RouterLink} to={`#${DomId.HelpCustomizingViews}`}>
          this help topic.
        </Link>
      </Typography>
      <Typography variant='body1'>
        While a basic search is helpful, you may want to further refine your
        result set. To do this, you can utilize the search refinement as shown
        below to be presented with some additional options. Each of these
        options work together, and can be combined to get your results as close
        to what you want as possible.
      </Typography>
      <HelpImage imageSrc={refineImage} alt='refine a search' />
      <Typography variant='body1'>
        There are a few items of note on the refine panel. One thing to take
        note of is the counter badge near a section header, this shows if a
        refinement filter is active or not, and how many selections within it
        are being used. To apply any refinements, you must choose the 'Apply'
        button. To discard your current changes and return to the current
        search, utilize the 'Cancel' button. If something has gone wrong, or you
        just want to get back to a minimal search of all items, you can choose
        the 'Reset' button, and then 'Apply' your changes.
      </Typography>
      <HelpImage imageSrc={activeRefineImage} alt='refine panel' />
      <Typography variant='body1'>
        If you still can't find what you are looking for, or are having issues,
        you can visit the{' '}
        <Link component={RouterLink} to={`#${DomId.HelpAdvancedSearch}`}>
          advanced search topic
        </Link>{' '}
        or the{' '}
        <Link component={RouterLink} to={`#${DomId.HelpMultiItemSearch}`}>
          multi item search topic
        </Link>
      </Typography>
    </Box>
  );
};

export default HelpGeneralPLP;
